module.exports = __webpack_public_path__ + "8d45236af6e5bf6a99e18711fa4a814b.jpg";